import { PlayCircleIcon } from '@phosphor-icons/react';
import styled from '@emotion/styled';

export const Container = styled.div`
  width: 100%;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 16px;
`;

export const UploadWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;

  .ant-upload-drag {
    /* padding: 20px !important; */
    min-height: 140px !important;
    height: auto !important;
    width: 100%;
    margin: 0 !important;
    border: 1px dashed #d9d9d9 !important;
    border-radius: 12px !important;
    background: #fafafa !important;
  }

  .ant-upload-select {
    width: 120px !important;
    height: 120px !important;
    margin: 0 !important;
  }

  .ant-upload {
    display: flex !important;
    align-items: center;
    justify-content: center;
  }

  .ant-upload-wrapper {
    width: 100%;
  }
`;

export const GalleryWrapper = styled.div`
  width: 100%;

  /* Override Gallery styles to standardize delete button position */
  .gallery-item {
    position: relative;

    .delete-button {
      position: absolute !important;
      top: 4px !important;
      right: 4px !important;
      opacity: 0 !important;
      transition: opacity 0.2s ease !important;
      background: rgba(0, 0, 0, 0.6) !important;
      color: white !important;
      border: none !important;
      border-radius: 4px !important;
      z-index: 10 !important;

      &:hover {
        background: rgba(0, 0, 0, 0.8) !important;
        color: white !important;
      }
    }

    &:hover .delete-button {
      opacity: 1 !important;
    }
  }
`;

export const DragUploadArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 8px;

  span {
    text-align: center;
    display: block;
  }
`;

export const UploadButton = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 104px;
  height: 104px;
  border: 1px dashed #d9d9d9;
  border-radius: 8px;
  background: #fafafa;
  transition: all 0.2s ease;
  cursor: pointer;
  text-align: center;

  &:hover {
    border-color: #1890ff;
    background: #f0f8ff;
  }

  .anticon {
    font-size: 16px;
    color: #999;
    margin-bottom: 4px;
  }

  span {
    text-align: center;
    display: block;
  }
`;

export const FileCount = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 8px;
  border-top: 1px solid #f0f0f0;
`;

// Remove unused styles since we're using Gallery component
export const FileGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(104px, 1fr));
  gap: 12px;
  margin-bottom: 16px;
`;

export const FileCard = styled.div<{ isDragging?: boolean }>`
  position: relative;
  width: 104px;
  height: 104px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  overflow: hidden;
  cursor: ${props => (props.isDragging ? 'grabbing' : 'grab')};
  transition: all 0.2s ease;
  background: #fafafa;

  &:hover {
    border-color: #1890ff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  &:hover .file-actions {
    opacity: 1;
  }

  &:hover .video-overlay {
    opacity: 1;
  }

  ${props =>
    props.isDragging &&
    `
    transform: rotate(2deg);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
    z-index: 1000;
  `}
`;

export const FilePreview = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;

export const VideoPreview = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

export const VideoOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.3);
  opacity: 0;
  transition: opacity 0.2s ease;
`;

export const PlayIcon = styled(PlayCircleIcon)`
  color: white;
  font-size: 24px;
`;

export const FileActions = styled.div`
  position: absolute;
  top: 4px;
  right: 4px;
  display: flex;
  gap: 4px;
  opacity: 0;
  transition: opacity 0.2s ease;

  .ant-btn {
    background: rgba(0, 0, 0, 0.6);
    color: white;
    border: none;

    &:hover {
      background: rgba(0, 0, 0, 0.8);
      color: white;
    }
  }
`;

export const FileType = styled.div`
  position: absolute;
  bottom: 4px;
  left: 4px;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 500;
`;

export const UploadSection = styled.div`
  .ant-upload-select {
    width: 104px !important;
    height: 104px !important;
    margin: 0 !important;
  }
`;
